// -----------------------------------------------------------------------------
// Scripts for contact form
// -----------------------------------------------------------------------------
$(function () {
  const contactFormModal = $('#contactFormModal');

  if(contactFormModal.length) {
    $('.menu-item').each(function(index, value) {
      const menuitem = $(this);
  
      if(menuitem.hasClass('contact-form')) {
        const menuLink = menuitem.find('a');
  
        menuLink.attr('data-bs-toggle', 'modal');
        menuLink.attr('data-bs-target', '#contactFormModal');
      }
    });
  }
});